// extracted by mini-css-extract-plugin
export default {"root":"lwthw6vcEE3B2cBiFlcg","wrap":"lBY0YbXUXF3LmtLkkprc","main":"San0PedLU_xXNKjDhFxQ","video":"UknNvWf6roCiw6hmyxht","delete":"j_7InutAi2YA8jbHy8TT","x":"dSe4oi9EShGemv3WCinD"};